var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDialAssociate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.09,20l-.26.17c-.53.35-2.46.19-4.06-2.66s-.82-4.68-.26-4.89l1.07-.65A1.13,1.13,0,0,0,13,10.52L11,6.8a1.13,1.13,0,0,0-1.42-.44c0,.08-1.14.62-1.14.71C6.82,8,6,9.8,6.11,12.4a15.29,15.29,0,0,0,2.2,6.85,17,17,0,0,0,4.77,5.4,8.49,8.49,0,0,0,1.95,1Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.52,25.74a1.05,1.05,0,0,1-.74-.26c-.12-.17,0-.49,0-.66l.21-.44a8.17,8.17,0,0,1,1.17-1.89,1,1,0,0,1,1.18-.19,2.4,2.4,0,0,1,.55.46,1.93,1.93,0,0,0,1.27.38h.39a1.88,1.88,0,0,0,1.21-.4,2.69,2.69,0,0,1,.55-.46.91.91,0,0,1,1.1.19,7.34,7.34,0,0,1,1.16,1.92l.22.42c.08.19.17.5.05.67a.85.85,0,0,1-.68.26Z",
    style: {
      fill: "#9767b8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.41,
    cy: 18.36,
    rx: 2.48,
    ry: 2.9,
    style: {
      fill: "#9767b8"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialAssociate);
export default __webpack_public_path__ + "static/media/dial-associate.674466e7.svg";
export { ForwardRef as ReactComponent };